const Bayi = resolve => {
    require.ensure(['../views/apps/bayi/Bayi'], () => {
        resolve(require('../views/apps/bayi/Bayi'))
    })
};
const BayiTanimlama = resolve => {
    require.ensure(['../views/apps/bayi/BayiTanimlama'], () => {
        resolve(require('../views/apps/bayi/BayiTanimlama'))
    })
};
const BayiListesi = resolve => {
    require.ensure(['../views/apps/bayi/BayiListesi'], () => {
        resolve(require('../views/apps/bayi/BayiListesi'))
    })
};

const BayiDuzenle = resolve => {
    require.ensure(['../views/apps/bayi/BayiDuzenle'], () => {
        resolve(require('../views/apps/bayi/BayiDuzenle'))
    })
};

import layouts from '../layout'

export default {
    path: '/bayi',
    name: 'bayi',
    component: Bayi,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'tanimlama',
            name: 'bayitanimlama',
            component: BayiTanimlama,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'liste',
            name: 'bayiliste',
            component: BayiListesi,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'guncelleme',
            name: 'bayiguncelle',
            component: BayiDuzenle,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
    ]
}
